import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./CardFooter.styled";
export const CardFooter = forwardRef((props, ref) => {
    const { backgroundColor, children, hasBorder, ...otherProps } = props;
    return (_jsx(Styled.CardFooter, { "data-testid": "CardFooter", ref: ref, backgroundColor: backgroundColor, hasBorder: hasBorder, ...otherProps, children: children }));
});
CardFooter.displayName = "CardFooter";
